import styled from 'styled-components';

export const MessageContainer = styled.div`
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    background-color: white;
    z-index: 100;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
`;

export const Wrapper = styled.div`
  margin-bottom: 40px;

  p {
    font-size: 18px;
    line-height: 23px;
    font-weight: 700;
    letter-spacing: 1.2px;
    span {
      color: #2863d0;
    }
  }
`;

export const WrapperButtons = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  button:first-child {
    margin-bottom: 15px;
  }
  
  @media (min-width: 680px) {
    flex-direction: row-reverse;
    justify-content: space-between;

    button:first-child {
    margin-bottom: 0;
  }
  }
`;
